import cloudinary from 'cloudinary-core'

const proxyUrl = process.env.IMAGE_PROXY && process.env.IMAGE_PROXY !== 'undefined' ? process.env.IMAGE_PROXY : ''
const cloudinaryName = process.env.CLOUDINARY && process.env.CLOUDINARY !== 'undefined' ? process.env.CLOUDINARY : ''
const enabled = { proxy: proxyUrl !== '', cloudinary: cloudinaryName !== '' }

const proxyRegex = new RegExp('^http[s]?://.*/(http[s]?://.*)$')

let cloudLib = null
if (enabled.cloudinary) {
  cloudLib = new cloudinary.Cloudinary({ cloud_name: cloudinaryName, secure: true })
}

const lib = {
  proxy: function (url, options = {}) {
    if (!enabled.cloudinary) {
      return lib.proxyWithImageProxy(url, options)
    }

    const cleanURL = lib.cleanURL(url)

    if (!lib.canProxy(cleanURL)) {
      return url
    }

    return lib.cloudinary(cleanURL, options)
  },
  proxyWithImageProxy: function (url, options) {
    const cleanURL = lib.cleanURL(url)

    if (!lib.canProxy(cleanURL)) {
      return url
    }

    const format = lib.format(options)
    return `${proxyUrl}/${format}/${cleanURL}`
  },
  canProxy: function (url) {
    if (!url || (!enabled.proxy && !enabled.cloudinary)) {
      return false
    }

    return url.substring(0, 4) === 'http'
  },
  cleanURL: function (url) {
    if (!url) {
      return ''
    }

    const match = url.match(proxyRegex)
    if (match) {
      url = decodeURIComponent(match[1])
    }

    return url
  },
  thumbnail: function (url) {
    return lib.proxy(url, { width: 64, height: 64, quality: 10 })
  },
  thumbnailXl: function (url) {
    return lib.proxy(url, { width: 128, height: 128, quality: 15 })
  },
  judges: function (url) {
    return lib.proxy(url, { width: 500, height: 800, quality: 25 })
  },
  judge: function (url) {
    return lib.proxy(url, { width: 260, height: 140, quality: 75 })
  },
  grid: function (url) {
    return lib.proxy(url, { width: 300, height: 300, quality: 75 })
  },
  projectSmall: function (url) {
    return lib.proxy(url, { width: 250, height: 250, quality: 75 })
  },
  project: function (url) {
    return lib.proxy(url, { width: 625, height: 500, quality: 80 })
  },
  projectCard: function (url) {
    return lib.proxy(url, { width: 276, height: 175, quality: 75 })
  },
  gameCard: function (url) {
    return lib.proxy(url, { width: 200, height: 200, quality: 75 })
  },
  imageOverlay: function (url) {
    return lib.proxy(url, { width: 5, height: 5, quality: 1 })
  },
  resourceCard: function (url) {
    return lib.proxy(url, { width: 350, height: 250, quality: 75 })
  },
  category: function (url) {
    return lib.proxy(url, { width: 120, height: 120, quality: 100 })
  },
  projectCardAvatar: function (url, params) {
    return lib.proxy(url, params)
  },
  format: function (options) {
    if (!options) {
      return ''
    }

    let format = ''
    if (options.width) {
      format = options.width
    }

    if (options.height) {
      format = `${format}x${options.height}`
    }

    if (options.fit) {
      format = `${format},fit`
    }

    if (!options.crop && !options.height && format !== '') {
      format = `${format}x`
    }

    if (options.rotate) {
      format = `${format ? `${format},` : ''}r${options.rotate}`
    }

    if (options.quality) {
      format = `${format ? `${format},` : ''}q${options.quality}`
    }

    if (options.format) {
      format = `${format ? `${format},` : ''}${options.format}`
    }

    if (options.toPng) {
      format = `${format},png`
    }

    return format
  },
  cloudinary: function (url, options) {
    const cloudinaryOptions = { type: 'fetch', crop: 'fill' }

    if (options.width) {
      cloudinaryOptions.width = options.width
    }

    if (options.height) {
      cloudinaryOptions.height = options.height
    }

    if (options.quality) {
      cloudinaryOptions.quality = options.quality
    }

    return cloudLib.url(url, cloudinaryOptions)
  }
}

export default lib
